import React from "react";

const PHMeter = ({ pH }) => {
  // pH scale colors
  const getColor = (value) => {
    if (value <= 7.0) return "#ef4444"; // Red for acidic
    if (value >= 7.8) return "#3b82f6"; // Blue for alkaline
    if (value >= 7.35 && value <= 7.45) return "#22c55e"; // Green for normal
    if (value < 7.35) return "#f97316"; // Orange for mild acidic
    return "#60a5fa"; // Light blue for mild alkaline
  };

  // Calculate position on the scale (0-100%)
  const getPosition = (value) => {
    // Map pH 6.8-7.8 to 0-100%
    const min = 6.8;
    const max = 7.8;
    const percentage = ((value - min) / (max - min)) * 100;
    return Math.max(0, Math.min(100, percentage));
  };

  const position = getPosition(pH);
  const color = getColor(pH);

  return (
    <div className="mb-6">
      <div className="flex justify-between mb-1">
        <span className="text-red-400 font-medium">Acidic</span>
        <span className="font-bold text-lg text-white">{pH.toFixed(2)}</span>
        <span className="text-blue-400 font-medium">Alkaline</span>
      </div>

      <div className="relative h-8 bg-gradient-to-r from-red-500 via-green-500 to-blue-500 rounded-full shadow-lg">
        <div
          className="absolute top-0 w-4 h-8 -ml-2 bg-white border-2 border-gray-900 rounded-full shadow-xl"
          style={{ left: `${position}%` }}
        ></div>

        {/* Normal range indicator */}
        <div
          className="absolute top-0 h-8 bg-white opacity-30 border border-green-300"
          style={{
            left: `${getPosition(7.35)}%`,
            width: `${getPosition(7.45) - getPosition(7.35)}%`,
          }}
        ></div>

        {/* pH value labels */}
        <div className="absolute -bottom-6 left-0 text-xs text-gray-400">6.8</div>
        <div className="absolute -bottom-6 left-1/4 text-xs text-gray-400">7.1</div>
        <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 text-xs text-gray-300">
          7.4
        </div>
        <div className="absolute -bottom-6 left-3/4 text-xs text-gray-400">7.6</div>
        <div className="absolute -bottom-6 right-0 text-xs text-gray-400">7.8</div>
      </div>
    </div>
  );
};

export default PHMeter;
